module.exports = ".content{\r\n    margin: auto !important\r\n}"